import { BaseeSearchClass } from 'projects/Shared-Lib/model/search-result';
import { SelectListItem } from '../lib/select/select-property';
import { DataService } from 'projects/Shared-Lib/services/data.service';

const ControllerName: string = 'RoleUsers';

//search filter request api fields
export class SearchClass extends BaseeSearchClass {
    RoleId?: string;
    //RoleName?: string;
    UserName?: string;
}


//structure of table for postback api
export class RoleUsers {
    //[Key] - Guid
    RoleId?: string;
    RoleName?: string;
    UserName?: string;
    UserAccount?: string;
    UpdatedBy?: string;
    UpdatedDateTime?: string;

    constructor() {
    }
}

/** Role Search class */
export class RoleUsers_Search {
    filter: SearchClass;
    ddlRole?: SelectListItem[];
    SelectedRole?: SelectListItem;

    constructor() {
        this.filter = new SearchClass();
        this.filter.RoleId = '0';
        this.filter.UserName = '';
    }
}


/** document edit/create page models */
export class RoleUsers_Document extends RoleUsers {
    ddlRole?: SelectListItem[];
    SelectedRole?: SelectListItem;

    CurrentUser: any;
    ListUsers: any;

    constructor(private dataService: DataService) {
        super();
        this.CurrentUser = JSON.parse(localStorage.getItem('user'));
        //this.ddlRole = [{ value: '0', text: 'Default blank', index: 0 }];
    }

    /** Get Document by UserId
     * @param uid : Guid
     */
    GetDocument(uid: string) {
        this.dataService.getData(`${ControllerName}/${uid}`, null, (ret) => {
            // console.log(ret);
            this.ListUsers = ret;
        });
    }
}
